<div [matMenuTriggerFor]="userActions">

    <div *ngIf="photo" class="flex-0 w-8 h-8 rounded-full overflow-hidden cursor-pointer">
        <img class="w-full h-full object-cover" src="{{photo}}">
    </div>
    <div *ngIf="!photo" class="flex-0 w-8 h-8 rounded-full overflow-hidden cursor-pointer">
        <img class="w-full h-full object-cover" src="assets/images/avatars/profile.png">
    </div>

</div>

<mat-menu [xPosition]="'before'" #userActions="matMenu">

    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span class="mt-1.5 text-md font-medium">{{user.FirstName}} {{user.LastName}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item (click)="onAccount()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{'Label.Account' | transloco}}</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{'Label.End' | transloco}}</span>
    </button>
</mat-menu>